import React, { useState } from "react";
import { Link } from "react-scroll";
import { Fade } from "react-reveal";
function Nav() {
  const [style, setStyle] = useState("< Tee~Codes / >");
  function news() {
    setStyle("<Tee~Codes/>");
  }
  // window.onscroll = function(){
  //   myFunction()
  // }
  // const navbar = document.querySelector(".navbar")
  // const sticky = navbar.offsetTop
  // function myFunction(){
  //   if(window.pageYOffset >= sticky){
  //     navbar.classList.add("sticky")
  //   }else{
  //     navbar.classList.remove("sticky")
  //   }
  // }
  return (
    <div>
      <Fade duration={1000} top>
        <nav className=" navbar fixed-top">
          <div className="container-fluid">
            <Link
              to="home"
              className="navbar-brand"
              style={{
                color: "white",
                fontFamily: "",
                fontStyle: "",
                fontWeight: "bolder",
                cursor: "pointer",
              }}
            >
              <span style={{ fontSize: "20px", color: "white" }}>
                <i className=""></i>
              </span>
              {style}
            </Link>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNavAltMarkup"
              aria-controls="navbarNavAltMarkup"
              aria-expanded="false"
              aria-label="Toggle navigation"
              style={{ background: "white" }}
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
              <div className="ul" style={{ cursor: "pointer" }}>
                <b>
                  <Link
                    to="home"
                    spy={true}
                    smooth={true}
                    offset={-100}
                    duration={100}
                    className="nav-link"
                  >
                    <span
                      style={{
                        color: "gray",
                        fontWeight: "bolder",
                      }}
                    >
                      <i className="fa fa-home"></i>
                    </span>
                    Home
                  </Link>
                </b>
                <b>
                  <Link
                    to="about"
                    spy={true}
                    smooth={true}
                    offset={-100}
                    duration={100}
                    className="nav-link"
                  >
                    <span
                      style={{
                        color: "gray",
                        fontWeight: "bolder",
                      }}
                    >
                      <i className="fa fa-network-wired"></i>
                    </span>
                    About
                  </Link>
                </b>
                <b>
                  <Link
                    to="skill"
                    spy={true}
                    smooth={true}
                    offset={-100}
                    duration={100}
                    className="nav-link"
                  >
                    <span
                      style={{
                        color: "gray",
                        fontWeight: "bolder",
                      }}
                    >
                      <i className="fa fa-chart-line"></i>
                    </span>
                    Skills
                  </Link>
                </b>
                <b>
                  <Link
                    to="project"
                    spy={true}
                    smooth={true}
                    offset={-100}
                    duration={100}
                    className="nav-link"
                  >
                    <span
                      style={{
                        color: "gray",
                        fontWeight: "bolder",
                      }}
                    >
                      <i
                        className="fa fa-tasks"
                        style={{ textDecoration: "none" }}
                      ></i>
                    </span>
                    Projects
                  </Link>{" "}
                </b>
                <b>
                  <Link
                    to="contact"
                    spy={true}
                    smooth={true}
                    offset={-100}
                    duration={100}
                    className="nav-link"
                  >
                    <span
                      style={{
                        color: "gray",
                        fontWeight: "bolder",
                      }}
                    >
                      <i className="fa fa-address-book"></i>
                    </span>
                    Contact Me
                  </Link>
                </b>
              </div>
            </div>
          </div>
        </nav>
      </Fade>
    </div>
  );
}

export default Nav;
